/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { RenamePasskeyOptions, RenamePasskeyResponses } from '../models/RenamePasskey'
import { client } from '#shared/api/client'

/**
 * @summary Renames one of the account's passkeys.
 * {@link /api/passkeys/:id}
 */
export function renamePasskey<ThrowOnError extends boolean = true>(options: Options<RenamePasskeyOptions, ThrowOnError>): Promise<RequestResult<RenamePasskeyResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'PATCH', url: '/api/passkeys/{id}', security: [{ type: 'apiKey', name: 'cas_session', in: 'cookie' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<RenamePasskeyResponses, ThrowOnError>>
}
